import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import get from 'lodash/get'
import { Text, Checkbox, ColorPicker, DateTimePicker } from 'components/forms'
import Divider from 'components/Divider'
import { ImageUploaderS3 } from 'components/Image'
import { FormRow, FormCol } from 'style/styled'
import { useTranslation } from 'react-i18next'

const SelfCheckout = ({ formData, updateItem, itemId: id }) => {
	const [t] = useTranslation()
	const imagePath = `kioskImg/${id}/`

	const handleUpload = field => key => {
		updateItem({
			parameters: {
				[field]: key
			}
		})
	}

	const handleRemove = field => key => {
		updateItem({
			parameters: {
				[field]: null
			}
		})
	}

	return(
		<>
			<Row>
				<Col xs>
					<Text field='parameters.settingsPassword' label={t('options_section.fields.settings_pin_code')} />
					<Checkbox field='parameters.showOrderViewKiosk' label={t('options_section.fields.display_order_screen')} />
					<Checkbox field='parameters.useOldDesign' label={t('options_section.fields.selfcheckout_old_design')} />
					<Checkbox field='parameters.isMainScreenWithVideo' label={t('options_section.fields.first_page_video')} />
					<Checkbox field='parameters.hasFastLine' label={t('options_section.fields.use_fast_line')} />
					<Checkbox field='parameters.multiLanguage' label={t('options_section.fields.activate_multilingualism')} />
					<Checkbox field='parameters.disallowLoyaltyCards' label={t('options_section.fields.customer_card_prohibited')} />
					<Checkbox field='parameters.displayEitherCategoriesOrProducts' label={t('options_section.fields.show_categories_or_products')} />
				</Col>
				<Col xs={3}>
					<ColorPicker field='parameters.cardTextColor' label={t('options_section.fields.customer_card_text_color')} />
					<ColorPicker field='parameters.accentColor' label={t('options_section.fields.accent_color')} />
					<DateTimePicker
						field='parameters.closingTime'
						label={t('options_section.fields.completion_time')}
						picker='time'
						addDateToTime={false}
						shrink
					/>
				</Col>
				<Col xs={2}>
					<ColorPicker field='parameters.textColor' label={t('options_section.fields.textColor')} />
					<ColorPicker field='parameters.backgroundColor' label={t('options_section.fields.backgroundColor')} />
				</Col>
			</Row>
			<Divider/>
			<FormRow>
				<FormCol xs autoWidth>
					<ImageUploaderS3
						imgKey={get(formData, 'parameters.mainScreenLogo')}
						onUpload={handleUpload('mainScreenLogo')}
						onRemove={handleRemove('mainScreenLogo')}
						label={t('options_section.fields.logo_image')}
						s3UploadKey={`${imagePath}mainScreenLogo`}
						width={263}
						height={133}
					/>
				</FormCol>
				<FormCol xs autoWidth>
					<ImageUploaderS3
						imgKey={get(formData, 'parameters.loyaltyCardImg')}
						onUpload={handleUpload('loyaltyCardImg')}
						onRemove={handleRemove('loyaltyCardImg')}
						label={t('options_section.fields.customer_card_image')}
						s3UploadKey={`${imagePath}loyaltyCardImg`}
						width={450}
						height={279}
					/>
				</FormCol>
				<FormCol xs autoWidth>
					<ImageUploaderS3
						imgKey={get(formData, 'parameters.loyaltyCardIcon')}
						onUpload={handleUpload('loyaltyCardIcon')}
						onRemove={handleRemove('loyaltyCardIcon')}
						label={t('options_section.fields.customer_card_icon')}
						s3UploadKey={`${imagePath}loyaltyCardIcon`}
						width={168}
						height={103}
					/>
				</FormCol>
			</FormRow>
			<FormRow>
				<FormCol xs autoWidth>
					<ImageUploaderS3
						imgKey={get(formData, 'parameters.takeOutImg')}
						onUpload={handleUpload('takeOutImg')}
						onRemove={handleRemove('takeOutImg')}
						label={t('options_section.fields.take_out_image')}
						s3UploadKey={`${imagePath}takeOutImg`}
						width={345}
						height={425}
					/>
				</FormCol>
				<FormCol xs autoWidth>
					<ImageUploaderS3
						imgKey={get(formData, 'parameters.inCafeImg')}
						onUpload={handleUpload('inCafeImg')}
						onRemove={handleRemove('inCafeImg')}
						label={t('options_section.fields.in_cafe_image')}
						s3UploadKey={`${imagePath}inCafeImg`}
						width={345}
						height={425}
					/>
				</FormCol>
			</FormRow>
		</>
	)
}

export default SelfCheckout
